import { useState } from 'react';

import { useDispatch } from 'react-redux';

import { useRouter } from '@whelk/hooks/src/useRouter';
import { getTargetChatHistory } from '@whelk/services/src/chat';
import {
  setChatId,
  setChatList,
  setChatTitle,
  setCanSearch,
} from '@whelk/store/slices/chatListSlice';
import { setInputMode, INPUT_MODE } from '@whelk/store/slices/inputSlice';
import { handleActiveHistoryItemData } from '@whelk/utils/src/textSseUtils';
import { store } from '@whelk/store';
import { isOverseas } from '@whelk/const/src/env';

export default function useChatEditor() {
  const nav = useRouter();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  // 获取历史数据对话
  const onGetTargetChatHistory = async ({
    chatID,
    afterCb,
    catchCb,
    setTargetModel,
  }: {
    chatID: string;
    afterCb?: (needRequestSystemId: string, isRePull: boolean) => void;
    catchCb?: (err: any) => void;
    setTargetModel?: (model: string) => void;
  }) => {
    try {
      setLoading(true);
      dispatch(setInputMode(INPUT_MODE.UNABLE));
      const chatListData = await getTargetChatHistory(chatID);
      const { messages = [], title = '', canSearch = true, model = '' } = chatListData;

      const { newMessageList, isRePull, needRequestSystemId } =
        handleActiveHistoryItemData(messages);

      // 历史返回数据不能为空数组，否则走 catch error 开启新对话逻辑
      if (newMessageList?.length === 0) {
        nav.push('/');
        throw new Error('历史对话数据异常，开启新对话');
      }

      dispatch(setChatId(chatID));
      if (setTargetModel && isOverseas) {
        setTargetModel(model);
      }
      // setModel(model);
      dispatch(setChatList(newMessageList));
      dispatch(setChatTitle(title));
      dispatch(setCanSearch(canSearch));

      // after
      afterCb && afterCb(needRequestSystemId, isRePull);
    } catch (err) {
      // catch
      catchCb && catchCb(err);
    } finally {
      setLoading(false);
    }
  };
  // 删除当前对话
  const onDeleteCurrentChatMsgIds = async (checkedMsgIds: string[]) => {
    const chatList = store.getState()?.chat?.chatList || [];

    // 找出需要保留的消息ID集合
    const idsToKeep = new Set<string>();

    // 收集要删除的消息及其相关消息的ID
    chatList.forEach((chat, index) => {
      if (checkedMsgIds.includes(chat.msgId)) {
        // 如果是用户消息，保留这条消息和AI的回复
        if (chat.msgType === 'user') {
          idsToKeep.add(chat.msgId);
          idsToKeep.add(chatList[index + 1].msgId);
        }
        // 如果是AI消息，保留这条消息和触发它的用户消息
        else {
          idsToKeep.add(chat.msgId);
          idsToKeep.add(chatList[index - 1].msgId);
        }
      }
    });
    // 过滤保留需要的消息
    const newChatList = chatList.filter((chat) => !idsToKeep.has(chat.msgId));

    dispatch(setChatList(newChatList));
  };
  return {
    onGetTargetChatHistory,
    loading,
    onDeleteCurrentChatMsgIds,
  };
}
